import { Search, Percent, Users, Handshake, BadgeCheck, TrendingUp, type LucideIcon } from "lucide-react";

export interface BrokerBenefit {
  icon: LucideIcon;
  title: string;
  description: string;
}

export const brokerBenefits: BrokerBenefit[] = [
  {
    icon: Search,
    title: "Busca inteligente de permutas",
    description:
      "A plataforma cruza automaticamente os imóveis da sua carteira com oportunidades de permuta. Sem buscas manuais.",
  },
  {
    icon: Percent,
    title: "Taxa reduzida de 0,9%",
    description:
      "Condição exclusiva para corretores cadastrados: apenas 0,9% sobre o valor da permuta concluída.",
  },
  {
    icon: Users,
    title: "Gestão de clientes",
    description:
      "Associe imóveis a clientes e gerencie toda sua carteira de permutas em um único lugar.",
  },
  {
    icon: Handshake,
    title: "Mais negócios fechados",
    description:
      "Encontre trocas que antes não aconteceriam. Aumente significativamente sua taxa de conversão.",
  },
  {
    icon: BadgeCheck,
    title: "Selo de corretor verificado",
    description:
      "Valide seu CRECI e ganhe credibilidade junto aos proprietários da plataforma.",
  },
  {
    icon: TrendingUp,
    title: "Métricas de desempenho",
    description:
      "Acompanhe seus resultados: imóveis cadastrados, matches gerados e negociações concluídas.",
  },
];